import { createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

interface UserRole {
  id: string;
  name: string;
}

interface UserData {
  id: string;
  login: string;
  first_name: string;
  second_name: string;
  last_name: string;
  avatar_pic: string | null;
  date_of_birth: string;
  email: string;
  phone: string;
  roles: UserRole[];
}

interface AuthState {
  isLogin: boolean;
  isRequest: boolean;
  userData: UserData;
}

const initialState: AuthState = {
  isLogin: false,
  isRequest: false,
  userData: {
    id: "",
    login: "",
    first_name: "",
    second_name: "",
    last_name: "",
    avatar_pic: null,
    date_of_birth: "",
    email: "",
    phone: "",
    roles: [],
  },
};

export const authSlice = createSlice({
  name: "authSlice",
  initialState,
  reducers: {
    login: (state) => {
      state.isLogin = true;
    },
    logout: (state) => {
      Cookies.remove("access_token");
      Cookies.remove("id_token");

      state.isLogin = false;
      state.userData = {
        id: "",
        login: "",
        first_name: "",
        second_name: "",
        last_name: "",
        avatar_pic: null,
        date_of_birth: "",
        email: "",
        phone: "",
        roles: [],
      };
    },
    updateUserData: (state, action) => {
      console.log('Updating user data in Redux:', {
        currentState: state.userData,
        newData: action.payload
      });
      state.userData = {
        ...state.userData,
        ...action.payload,
      };
      console.log('Updated user data in Redux:', state.userData);
    },
    updateIsRequest: (state, action) => {
      state.isRequest = action.payload;
    },
  },
});

export const { login, logout, updateUserData, updateIsRequest } = authSlice.actions;

export default authSlice.reducer;
